import { useEffect } from 'react'
// @ts-expect-error — tinykeys exports not resolved under moduleResolution: bundler
import { tinykeys } from 'tinykeys'
import { useStudioStore } from '@/store/studio-store'
import { handleManualSave } from '@/store/auto-save-bridge'
import { useToastStore } from '@/store/toast-store'
import type { WorkspaceMode } from '@/store/types'

const MODE_MAP: Record<string, WorkspaceMode> = {
  '1': 'chat',
  '2': 'page',
  '3': 'flow',
  '4': 'preview',
}

export function useStudioShortcuts() {
  useEffect(() => {
    const unsubscribe = tinykeys(window, {
      '$mod+KeyJ': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().toggleDiagnosticPanel()
      },
      '$mod+Shift+KeyD': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().toggleDevToolsPanel()
      },
      '$mod+KeyB': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().toggleNavPanel()
      },
      '$mod+KeyI': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().toggleInspectorPanel()
      },
      '$mod+Backslash': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().closeAllPanels()
      },
      '$mod+Digit1': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().setMode(MODE_MAP['1'])
      },
      '$mod+Digit2': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().setMode(MODE_MAP['2'])
      },
      '$mod+Digit3': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().setMode(MODE_MAP['3'])
      },
      '$mod+Digit4': (e: KeyboardEvent) => {
        e.preventDefault()
        useStudioStore.getState().setMode(MODE_MAP['4'])
      },
      '$mod+KeyS': (e: KeyboardEvent) => {
        e.preventDefault()
        handleManualSave().then((saved) => {
          if (saved) {
            useToastStore.getState().addToast({ message: 'Saved', type: 'success' })
          }
        })
      },
    })
    return unsubscribe
  }, [])
}
